import { Box, Stack, Typography } from '@mui/material';
import { BenefitsStackProps } from './BenefitsStack.interface';
import classes from './BenefitsStack.module.scss';
const BenefitsStack = ({
  benefit
}: BenefitsStackProps) => {
  return <Stack className={classes['benefits']} data-sentry-element="Stack" data-sentry-component="BenefitsStack" data-sentry-source-file="BenefitsStack.tsx">
			<Box className={classes['benefits__icon-container']} data-sentry-element="Box" data-sentry-source-file="BenefitsStack.tsx">{benefit.icon}</Box>
			<Box className={classes['benefits__container']} data-sentry-element="Box" data-sentry-source-file="BenefitsStack.tsx">
				<Typography variant="headingBenefit" className={classes['benefits__title']} data-sentry-element="Typography" data-sentry-source-file="BenefitsStack.tsx">
					{benefit.title}
				</Typography>
				<Typography variant="descriptionBenefit" className={classes['benefits__description']} data-sentry-element="Typography" data-sentry-source-file="BenefitsStack.tsx">
					{benefit.description}
				</Typography>
			</Box>
		</Stack>;
};
export default BenefitsStack;